import React, { useCallback } from "react";
import moment, { Moment } from "moment";
import DeclarantFilters from "../filters/declarantFilters";
import { LoadEntities } from "./Interfaces";
import { DateRangeDate, IObjectMap } from "../../interfaces/common";

interface Props {
  store?: LoadEntities;
  onChange?: (startDate: Moment | null, endDate: Moment | null) => void;
  startDate?: DateRangeDate;
  endDate?: DateRangeDate;
  allowClear?: boolean;
}

const DateRange: React.FC<Props> = ({
  store,
  startDate: sDate,
  endDate: eDate,
  allowClear = true,
  onChange,
}) => {
  const onChangeFiltersHandler = useCallback(
    (startDate: Moment | null, endDate: Moment | null): void => {
      if (store) {
        store.load(
          {
            page: 1,
            start_date: startDate,
            end_date: endDate,
          } as IObjectMap,
          true
        );
      }

      if (onChange) {
        onChange(startDate, endDate);
      }
    },
    [onChange, store]
  );

  return (
    <DeclarantFilters
      onChange={onChangeFiltersHandler}
      startDate={sDate}
      endDate={eDate}
      allowClear={allowClear}
    />
  );
};

export const defaultDateRange = {
  start_date: moment().subtract(1, "days"),
  end_date: moment(),
};

export default DateRange;
